import { msalInstance } from '../app/pages/LoginPage/components/AzureAdProvider';

export const getAccessToken = async () => {
  const accessTokenRequest = {
    scopes: ['user.read'],
  };
  const msalAccounts = msalInstance.getAllAccounts();
  if (msalAccounts.length === 0) {
    msalInstance.loginRedirect(accessTokenRequest).finally();
  }
  if (msalAccounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(msalAccounts[0]);
  }
  const getTokenResult = await msalInstance.acquireTokenSilent(
    accessTokenRequest,
  );
  return getTokenResult.accessToken;
};
